import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import getBrandGroups from '../../../../api/oc_product/brandGroup/get/getBrandGroup';
import getBrands from '../../../../api/oc_product/brands/gets/getBrands';
import { BrandGroupingContext } from './BrandGroupingContext';
import BrandGroupingBody from './components/BrandGroupingBody';
import BrandGroupingHeader from './components/BrandGroupingHeader';
import BrandGroupingLogs from './components/BrandGroupingLogs';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`brand-grouping-tabpanel-${index}`}
      aria-labelledby={`brand-grouping-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: '100%', py: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `brand-grouping-tab-${index}`,
    'aria-controls': `brand-grouping-tabpanel-${index}`,
  };
}

function BrandGroupingContainer() {
  const siteId = useSelector((state) => state.user.loginResponse?.selectedSite?.SiteId);

  const [brandGroups, setBrandGroups] = React.useState();
  const [brands, setBrands] = React.useState();
  const [fetchData, setFetchData] = React.useState(false);
  const [reFetchLogs, setReFetchLogs] = React.useState(false);

  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const fetchBrandGroups = () => {
    getBrandGroups(siteId)
      .then((res) => setBrandGroups(res.data))
      .catch((err) => console.error(err));
  };

  React.useEffect(() => {
    fetchBrandGroups();
    getBrands()
      .then((res) => {
        setBrands(res.data);
      })
      .catch((err) => console.error(err));
  }, [siteId]);

  React.useEffect(() => {
    if (fetchData) {
      fetchBrandGroups();
      setFetchData(false);
    }
  }, [fetchData]);

  const setBrandGroupFunc = (data) => {
    setBrandGroups(data);
  };

  const totalBrandGroupsCount = brandGroups ? brandGroups.length : 0;

  return (
    <BrandGroupingContext.Provider value={{
      setFetchData,
      brands,
      reFetchLogs,
      setReFetchLogs,
    }}
    >
      <Box
        sx={{
          width: '100%',
          minHeight: '100vh',
          backgroundColor: '#FAF9F6',
        }}
      >
        <div className="flex w-[90%] flex-col gap-2 pt-2 mx-auto mt-4">
          <BrandGroupingHeader
            brandGroups={brandGroups}
            setBrandGroups={setBrandGroupFunc}
            totalGroupsCount={totalBrandGroupsCount}
          />

          <Box
            sx={{
              backgroundColor: '#34495e',
              mt: 0,
              borderRadius: '12px 12px 0 0',
              overflow: 'hidden',
              '& .MuiTabs-root': {
                minHeight: '50px',
                height: '50px',
              },
              '& .MuiTabs-flexContainer': {
                minHeight: '50px',
                height: '50px',
              },
              '& .MuiTabs-indicator': {
                height: '4px',
                backgroundColor: '#1abc9c',
                borderRadius: 0,
              },
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="Brand Grouping and Logs tabs"
              variant="fullWidth"
            >
              <Tab
                label="BRAND GROUP"
                {...a11yProps(0)}
                sx={{
                  color: '#bdc3c7',
                  textTransform: 'uppercase',
                  fontWeight: 400,
                  backgroundColor: 'transparent',
                  // Force white color when selected
                  '&.Mui-selected': {
                    color: 'white',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              />
              <Tab
                label="LOGS"
                {...a11yProps(1)}
                sx={{
                  color: '#bdc3c7',
                  textTransform: 'uppercase',
                  fontWeight: 400,
                  backgroundColor: 'transparent',
                  '&.Mui-selected': {
                    color: 'white',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              />
            </Tabs>
          </Box>

          <TabPanel value={activeTab} index={0}>
            <Divider sx={{ borderTopWidth: 1, mt: 0 }} />
            <BrandGroupingBody brandGroups={brandGroups} />
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <Box sx={{ mt: 0 }}>
              <BrandGroupingLogs />
            </Box>
          </TabPanel>
        </div>
      </Box>
    </BrandGroupingContext.Provider>
  );
}

export default BrandGroupingContainer;
